/*
 * Transform API data into format needed for Table component
 */

import { QUESTION_TYPES } from '../../../constants/props';

import { QUESTION } from './handleValue';
import { TITLE_COLUMN } from './sorting';
import getQuestionType from './getQuestionType';
import getScaleDescription from './getScaleDescription';

export default (questions, assignments, singleModeView) => {
  if (!assignments) return [];

  return questions
    .reduce((tableRows, question) => {
      // create new row starting with question text cell in title column
      const rowStart = { [TITLE_COLUMN]: { ...question, type: QUESTION } };
      const type = getQuestionType(question);
      const description =
        type === QUESTION_TYPES.scale ? getScaleDescription(question) : null;
      const { parentQuestionId, triggeredOnParentValue } = question;

      // add to row answer cells
      const row = assignments.reduce((acc, assignment) => {
        const { answers, assignmentId } = assignment;

        const questionAnswers = answers.filter(
          answer => answer.questionId === question.id,
        );
        const answer = questionAnswers[0] || { value: '-' };

        const { value: parentQuestionValue } = answers.find(
          item => item.questionId === parentQuestionId,
        ) || { value: '' };

        const shouldHideQuestion = triggeredOnParentValue
          ? parentQuestionValue !== triggeredOnParentValue
          : false;

        if (shouldHideQuestion && singleModeView) {
          acc.shouldHideQuestions = true;
        }

        acc[assignmentId] = shouldHideQuestion
          ? null
          : {
              ...answer,
              description,
              type,
            };

        return acc;
      }, rowStart);
      return [...tableRows, row];
    }, [])
    .filter(
      r => !r.shouldHideQuestions && Object.values(r).some(i => i && i.value),
    );
};



// WEBPACK FOOTER //
// ./src/components/Survey/helpers/getRows.js